import React from 'react'
import { Button, Dialog, DialogContent, Fab } from '@mui/material'

import s from './styles.module.scss'

const FloatingActionWithDialog = ({ icon, children, open, setOpen }) => {
  const handleOpen = () => setOpen(true)
  const handleClose = () => {
    localStorage.setItem('tallyFormDismissed-EP', 'true')
    setOpen(false)
  }
  return (
    <>
      <Fab
        color="secondary"
        onClick={handleOpen}
        sx={{ position: 'fixed', bottom: 90, right: 15, zIndex: 2000, width: 75, height: 70, fontSize: 13 }}
      >
        Completá
      </Fab>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm" classes={{ paper: s.paperProps }}>
        <DialogContent
          sx={{
            overflow: 'hidden',
            p: 0,
          }}
        >
          <Button onClick={handleClose} className={s.closeBtn}>
            X
          </Button>

          {children}
        </DialogContent>
      </Dialog>
    </>
  )
}

export default FloatingActionWithDialog
